<template lang="pug" src="./v-locale.pug"> </template>
<script>
export default {
    props: {
      controlled: {
        type: Boolean,
        default: false
      },
      value: {
        type: String,
        default: 'uk'
      }
    },
    data: () => ({
        currentLang: '',
        locales: []
    }),
    computed: {
        modelToUse() {
            return this.controlled ? this.value : this.currentLang;
        }
    },
    created: function() {
        this.locales = Object.keys(this.$vuetify.lang.locales);

        if (!this.controlled) {
            this.currentLang = this.$vuetify.lang.current;
        }
    },
    methods: {
        changeLocale: function(lang) {
            if (this.locales.includes(lang)) {
                if (this.controlled) {
                  this.$emit('input', lang);
                } else {
                  window.localStorage.setItem('locale', lang);

                  this.currentLang = lang;
                  this.$vuetify.lang.current = lang;
                }
            }
        }
    }
};
</script>
